module.exports = __webpack_public_path__ + "img/arena_1.ddee57e5.svg";